export const styles = {
  root: {
    maxHeight: '200px !important',
    overflow: 'auto !important',
    display: 'flex',
    flexDirection: 'row',
    width: '224px',
    padding: '8px 12px',
    '&[aria-selected="true"]': {
      backgroundColor: '#EEF1FF !important',
    },
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    maxWidth: '224px',
    overflow: 'hidden',
  },
  iconWrapper: (color: string) => ({
    background: color,
    width: '24px',
    height: '24px',
    borderRadius: '8px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: 0,
  }),
  text: {
    color: '#23252F',
    fontFamily: 'Inter',
    lineHeight: '146%',
    fontSize: '14px',
    fontWeight: 500,
    flex: 1,
    minWidth: 0,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
};
